import React, { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { toggleFavorite, isFavorite, onFavoritesChange } from "../lib/favorites";

export const FavoriteButton = ({ product }) => {
  const [fav, setFav] = useState(false);

  useEffect(() => {
    if (!product?.slug) return;
    setFav(isFavorite(product.slug));
    const off = onFavoritesChange(() => setFav(isFavorite(product.slug)));
    return off;
  }, [product?.slug]);

  if (!product?.slug) return null;

  const handle = () => {
    toggleFavorite({
      slug: product.slug,
      productName: product.productName,
      brand: product.brand,
      overallScore: product.overallScore,
      overallRating: product.overallRating,
    });
  };

  return (
    <button
      onClick={handle}
      data-testid="favorite-btn"
      className={`ghost-btn rounded-lg px-3 py-1.5 text-sm inline-flex items-center gap-2 transition-colors ${
        fav ? "text-[color:var(--danger)] border-[color:var(--danger)]/40" : ""
      }`}
      aria-pressed={fav}
      aria-label={fav ? "Remove from favorites" : "Save to favorites"}
    >
      <Heart className="h-3.5 w-3.5" fill={fav ? "#FF3B3B" : "none"} strokeWidth={2} />
      {fav ? "Saved" : "Save"}
    </button>
  );
};

export default FavoriteButton;
